import { api } from "@/lib/api";

/**
 * Google Health step sync has been discontinued — steps now sync only through
 * the iOS (Apple Health) and Android (Health Connect) apps. These two
 * functions remain so legacy connections can be surfaced and cleaned up as
 * part of the in-app migration flow; there is no way to create a new
 * connection anymore.
 */
export async function getGoogleHealthConnectionStatus(): Promise<{
  connected: boolean;
  lastSyncAt: string | null;
}> {
  const res = await api.get<{ connected: boolean; lastSyncAt: string | null }>(
    "/sync/google/status",
  );
  if (res.error) {
    return { connected: false, lastSyncAt: null };
  }
  return res.data as { connected: boolean; lastSyncAt: string | null };
}

export async function disconnectGoogleHealth(): Promise<{ success: boolean; error?: string }> {
  const res = await api.post("/sync/google/disconnect");
  if (res.error) {
    return { success: false, error: res.error.message };
  }
  return { success: true };
}
